export const RATE_PRECISION = 8;
